import React from 'react';
import {View, TextInput, StyleSheet, TouchableOpacity, Text} from 'react-native';
import {useTranslation} from 'react-i18next';

interface SearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  onClear?: () => void;
  placeholder?: string;
  autoFocus?: boolean;
  editable?: boolean;
  onFocus?: () => void;
}

// Dit is de zoekbalk (duh)
const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChangeText,
  onClear,
  placeholder,
  autoFocus = false,
  editable = true,
  onFocus,
}) => {
  const {t} = useTranslation();

  return (
    <View style={stijlen.container}>
      <Text style={stijlen.icon}>🔍</Text>
      <TextInput
        style={stijlen.input}
        value={value}
        onChangeText={onChangeText}
        onFocus={onFocus}
        placeholder={placeholder || t('search.placeholder') || 'Zoek...'}
        placeholderTextColor="#999"
        autoFocus={autoFocus}
        autoCapitalize="none"
        autoCorrect={false}
        returnKeyType="search"
        editable={editable}
      />
      {value.length > 0 && onClear && (
        <TouchableOpacity onPress={onClear} style={stijlen.clearButton}>
          {/* Weg ermee knopje (X) */}
          <Text style={stijlen.clearIcon}>✕</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const stijlen = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 24,
    paddingHorizontal: 16,
    paddingVertical: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  icon: {
    fontSize: 20,
    marginRight: 8,
  },
  input: {
    flex: 1,
    fontSize: 16,
    color: '#333',
  },
  clearButton: {
    padding: 8,
    marginLeft: 8,
  },
  clearIcon: {
    fontSize: 18,
    color: '#999',
  },
});

export default SearchBar;
